<template>
  <div class="error">
    <div class="row error-container">
      <div class="col-md-12 error-content error-image-content" v-if="comp">
        <component :is="comp"></component>
      </div>
      <div class="col-md-12 error-content error-notice-content">
        <div>
          <div class="notice-title">{{ code }}</div>
          <div class="notice-detail">{{ desc }}</div>
          <el-button type="primary" @click="returnIndex">返回首页</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorContent',
  props: {
    code: {
      type: [String, Number]
    },
    desc: {
      type: String
    },
    comp: {
    }
  },
  methods: {
    returnIndex () {
      const that = this
      that.$router.push('/index')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@style/_var.scss";
@import "~@style/_theme.scss";
.error{
  text-align: center;
  .notice-title{
    font-size: 40px;
    color: $colorPrimary;
  }
  .notice-detail{
    margin: 16px 0 24px;
  }
}
</style>
